/** Loading placeholder shaped like real content — design-language §7. */
export function Skeleton({ className = '' }: { className?: string }) {
  return (
    <div
      className={`animate-pulse rounded-[var(--radius-sm)] bg-surface-2 ${className}`}
    />
  );
}

export function PageSkeleton() {
  return (
    <div className="space-y-6 p-4 md:p-6">
      <Skeleton className="h-8 w-48" />
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        <Skeleton className="h-20" />
        <Skeleton className="h-20" />
        <Skeleton className="h-20 max-lg:hidden" />
        <Skeleton className="h-20 max-lg:hidden" />
      </div>
      <Skeleton className="h-64" />
    </div>
  );
}
